import { BaseModel } from "src/app/models/base.model";
import { IUploadedFile } from "src/app/services/file.service";


export interface IBrandChart {
    files: IUploadedFile[];
    comment?: string;
}

export class BrandChart extends BaseModel<IBrandChart> implements IBrandChart {

    files: IUploadedFile[];
    comment?: string = undefined;

    constructor(data: Partial<BrandChart> = {}) {
        super();
        this.patch(data);
    }
}